import SearchBox from "./SearchBox";
import { appAction, modalType, addManualRequest, plexbotColors } from "./helpers";
import { CircularProgress, Stack, Card, CardContent, Typography, Box } from "@mui/material";
import AddCommentIcon from "@mui/icons-material/AddComment";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ListTitle from "./ListTitle";
import { STRING_SEARCH_NO_RESULTS } from "./strings";

const SearchPage = ({ appState, dispatch }) => {
    const searching = appState.searching;

    return (
        <div>
            <SearchBox
                appState={appState}
                dispatch={dispatch}
            />
            {searching &&
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '25px' }}>
                    <CircularProgress />
                </div>
            }
            {appState.searchResults !== null && (appState.searchResults?.titles?.length ?? 0) === 0 &&
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '25px' }}>
                    {appState.searchResults?.message ?? STRING_SEARCH_NO_RESULTS}
                </div>
            }
            <Stack direction="column" spacing={2} marginTop={2}>
                {(appState.searchResults?.titles ?? []).map(title => (
                    <div
                        style={{ cursor: 'pointer' }}
                        key={title.imdb_id}
                        onClick={() => {
                            dispatch({ type: appAction.update, value: { modalItem: title, modalType: modalType.title } })
                        }}
                    >
                        <ListTitle key={title.imdb_id} title={title} />
                    </div>
                ))}
                {appState.searchResults !== null && (
                    <div
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                            if (appState.manualRequestMade === false) {
                                dispatch({ type: appAction.update, value: { manualRequestMade: null } });
                                addManualRequest(appState.previousSearchTerm)
                                    .then(() => {
                                        dispatch({ type: appAction.update, value: { manualRequestMade: true } });
                                    })
                                    .catch(() => {
                                        dispatch({ type: appAction.update, value: { manualRequestMade: false } });
                                    });
                            }
                        }}
                    >
                        <Card sx={{ display: 'flex', position: 'relative', userSelect: 'none' }}>
                            <Box sx={{
                                width: 100,
                                minWidth: 100,
                                height: 100,
                                flexShrink: 0,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                backgroundColor: 'grey.800'
                            }}>
                                {
                                    appState.manualRequestMade === true
                                        ? <CheckCircleOutlineIcon sx={{ fontSize: 40, color: plexbotColors.have }} />
                                        : appState.manualRequestMade === null
                                        ? <CircularProgress sx={{ color: 'grey.400' }} />
                                        : <AddCommentIcon sx={{ fontSize: 40, color: 'grey.400' }} />
                                }
                            </Box>
                            <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                                <CardContent sx={{ flex: '1 0 auto', display: 'flex', flexDirection: 'column' }}>
                                    <Typography component="div" variant="h6">
                                        {appState.previousSearchTerm}
                                    </Typography>
                                    <Typography variant="subtitle1" color="text.secondary" component="div">
                                        {
}                                    {appState.manualRequestMade === true
                                            ? 'Requested'
                                            : appState.manualRequestMade === null
                                            ? 'Requesting...'
                                            : 'Press to request'}
                                    </Typography>
                                </CardContent>
                            </Box>
                        </Card>
                    </div>
                )}
            </Stack>
        </div>
    )
}

export default SearchPage;